import React from 'react';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { ReactComponent as EditIcon } from 'assets/img/icons/edit.svg';
import { ReactComponent as DeleteIcon } from 'assets/img/icons/delete-muted.svg';

export default function Actions({
  showActions = true,
  isDisabled = false,
  editRule = () => {},
  discardRule = () => {},
  children = null
}) {
  return (
    <div className={styles.footer}>
      <div>{children}</div>
      <If test={showActions}>
        <div className={styles.actions}>
          <UiKit.Button
            size="sm"
            variant="outline"
            onClick={editRule}
            disabled={isDisabled}
            className="p-0"
          >
            <EditIcon width="14" height="14" />
          </UiKit.Button>
          <UiKit.Button
            size="sm"
            variant="outline"
            onClick={discardRule}
            disabled={isDisabled}
            className="p-0"
          >
            <DeleteIcon width="14" height="14" />
          </UiKit.Button>
        </div>
      </If>
    </div>
  );
}
